<template>
  <router-view id="admin-dashboard" />
</template>

<script>
export default {};
</script>

<style lang="scss">
$main: #24a0ff;

#admin-dashboard {
  .md-datepicker {
    .md-icon {
      svg {
        fill: $main;
      }
    }
  }
}
</style>
